import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 5v5a5 5 0 0 0 10 0v-5","key":"svg-0"}],["path",{"d":"M5 19h14","key":"svg-1"}]]

/**
 * IconUnderline
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdW5kZXJsaW5lIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik03IDV2NWE1IDUgMCAwIDAgMTAgMHYtNSIgLz4KICA8cGF0aCBkPSJNNSAxOWgxNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/underline
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconUnderline = createReactComponent('outline', 'underline', 'Underline', __iconNode);

export default IconUnderline;